import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@25.9.5_@vue+compiler-sfc@3.5.41_cac@6.7.1_4r6qclturvbiep7j6bdfrzcnom/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}